import { useEffect, useRef, useState, useCallback } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Seo from "@/components/Seo";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import CategoryShowcase from "@/components/CategoryShowcase";
import ManifestoSection from "@/components/ManifestoSection";
import OrderFormSection from "@/components/OrderFormSection";
import FooterSection from "@/components/FooterSection";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function App() {
  const lenisRef = useRef(null);
  const [orderPrefill, setOrderPrefill] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollToSection = useCallback((id) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(`#${id}`, { offset: -72, duration: 1.4 });
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const handleSelectCategory = useCallback(
    (name) => {
      setOrderPrefill(`${name} — `);
      scrollToSection("order");
    },
    [scrollToSection]
  );

  return (
    <div className="min-h-screen bg-cream-50 text-charcoal-900 font-poppins overflow-x-clip">
      <Seo
        title="Az Haniza Enterprise — Premium Corporate Supply & Procurement"
        siteName="Az Haniza Enterprise"
        description="Az Haniza Enterprise delivers premium corporate supply, tailored procurement and dedicated logistics. Browse our product categories and place your order online."
        image="/assets/azh-logo.webp"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Az Haniza Enterprise",
          email: "azhanizaenterprise871@gmail.com",
          logo: "/assets/azh-logo.webp",
        }}
      />
      <Navbar onNavigate={scrollToSection} />
      <main>
        <HeroSection onNavigate={scrollToSection} />
        <CategoryShowcase onSelect={handleSelectCategory} />
        <ManifestoSection />
        <OrderFormSection prefill={orderPrefill} />
      </main>
      <FooterSection onNavigate={scrollToSection} />
      <WhatsAppFloat />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
